import React from 'react';
import {useSelector} from 'react-redux';
import {useState} from 'react';
import {
  Button,
  Modal,
  Form,
  Col,
} from 'react-bootstrap';
import DNS from 'components/DNS/dns.js';
import NotificationAlert from 'react-notification-alert';
import Moment from 'react-moment';


const ModalVIEWDELETEReservation = ({showModal, setShowModal,
  setShowModal3, getReservations, showResPk, showEventTitle,
  showEventName, showDebutDate, showDebutTime, showEndTime,
  showCreatedBy, start, end}) => {
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const currentBuilding = useSelector((state) => state.currentBuilding);
  const [showDeleteModal, setDeleteModal] = useState(false);

  const notificationAlertRef = React.useRef(null);
  const notify = (place) => {
    const type = 'success';
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>Votre réservation a bien été supprimée.</p>
          </div>
        </div>
      ),
      type: type,
      icon: 'nc-icon nc-check-2',
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const DeleteReservation = (event) => {
    event.preventDefault();
    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'token ' + token['tokenRedux'],
      },
      body: JSON.stringify({pk: showResPk}),
    };
    fetch(
        DNS +
      '/salle/crudReservation/' +
      currentBuilding['currentbuildingRedux'].pk +
      '/',
        requestOptions,
    ).then(async (response) => {
      const data = await response.json();
      if (data.status == 'OK') {
        notify('tc');
        setDeleteModal(false);
        getReservations(start, end);
        return;
      } else {
        console.log('FAILED REQUEST');
        return;
      }
    });
  };

  return (
    <>
      <NotificationAlert ref={notificationAlertRef}/>
      <Modal
        className="modal modal-primary"
        show={showDeleteModal}
        onHide={() => setDeleteModal(false)}
        onSubmit={DeleteReservation}
        autoFocus={false}
        enforceFocus={false}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon nc-notes"></i>
          </div>
        </Modal.Header>
        <div className="modal-body">
          <p className="text-center">
            Supprimer la réservation '{showEventName}' le {showDebutDate} de {showDebutTime} à {showEndTime}?
          </p>
          <Form>
            <Col style={{flex: 1}}>
              <Button className="btn-fill btn-round col-sm-6" type="submit">Supprimer</Button>
              <Button className="btn-fill btn-round col-sm-6" onClick={() => {
                setDeleteModal(false), setShowModal(true);
              }}>Annuler</Button>
            </Col>
          </Form>
        </div>
      </Modal>
      {/* ##################################### VIEW MODAL BELOW #################################################### */}
      <Modal
        className="modal modal-primary"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon nc-bulb-63"></i>
          </div>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>
            <i className="fas fa-id-badge"></i> Nom de la place :{' '}
            {showEventTitle}
          </p>
          {showCreatedBy.id == user['user'].pk ? (
          <p>
            <i className="fas fa-user-tie"></i> Titre de la
            réservation : {showEventName}
          </p>
        ) : null}
          <p>
            <i className="fas fa-calendar"></i> Reservé le :{' '}
            <Moment format="DD/MM/YYYY">{showDebutDate}</Moment>
          </p>
          <p>
            <i className="fas fa-clock"></i> De : {showDebutTime}
          </p>
          <p>
            <i className="fas fa-clock"></i> À : {showEndTime}
          </p>
        </Modal.Body>
        <div className="modal-body">
          {showCreatedBy.id == user['user'].pk ? (
          <div>
            <Button
              className="btn-round btn-warning col-md-4"
              onClick={() => {
                setShowModal(false);
                setShowModal3(true);
              }}
            >
              <i className="fas fa-edit"></i>
            </Button>
            <Button
              className="btn-round btn-danger col-md-4"
              onClick={() => {
                setDeleteModal(true), setShowModal(false);
              }}
            >
              <i className="fas fa-trash"></i>
            </Button>
            <Button
              className="btn-round btn-primary col-md-4"
              onClick={() => setShowModal(false)}
            >
              Fermer
            </Button>
          </div>
        ) : null}
        </div>
      </Modal>
    </>
  );
};

export default ModalVIEWDELETEReservation;
